import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';

interface ProtectedRouteProps {
  children: React.ReactNode;
  admin?: boolean;
}

// ProtectedRoute SIMPLIFICADO e ROBUSTO com novo sistema cross-tab
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, admin = false }) => {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [usuario, setUsuario] = useState<any>(null);
  
  useEffect(() => {
//     console.log('[PROTECTED-ROUTE] Verificando autenticação para:', location.pathname);
    
    performAuthCheck();
  }, [location.pathname, admin]);
  
  const performAuthCheck = async () => {
    try {
      // Aguardar inicialização do authService
      await authService.waitForInitialization();
      
      // Verificar autenticação
      const authResult = authService.isAuthenticated();
      const userResult = authService.getUsuario();
      
//       console.log('[PROTECTED-ROUTE] Resultado da verificação:', {
//         rota: location.pathname,
//         autenticado: authResult,
//         usuarioPresente: !!userResult,
//         rotaAdmin: admin,
//         cargoUsuario: userResult?.cargo,
//         sessao: {
//           token: !!sessionStorage.getItem('token'),
//           user: !!sessionStorage.getItem('user'),
//           empresa: !!sessionStorage.getItem('empresa')
//         }
//       });
      
      setIsAuthenticated(authResult);
      setUsuario(userResult);
      setIsChecking(false);
      
    } catch (error) {
      console.error('[PROTECTED-ROUTE] Erro durante verificação:', error);
      setIsAuthenticated(false);
      setUsuario(null);
      setIsChecking(false);
    }
  };
  
  // Mostrar loading enquanto verifica
  if (isChecking) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
        <div className="spinner-border" role="status">
          <span className="sr-only">Verificando autenticação...</span>
        </div>
      </div>
    );
  }
  
  // Verificar se o usuário está autenticado
  if (!isAuthenticated) {
//     console.log(`[PROTECTED-ROUTE] Acesso negado: usuário não autenticado para rota ${location.pathname}`, {
//       timestamp: new Date().toISOString(),
//       tokenPresente: !!sessionStorage.getItem('token')
//     });
    return <Navigate to="/login" replace />;
  }
  
  // Se for rota de admin, verificar se o usuário tem permissão
  if (admin && usuario?.cargo !== 'admin') {
//     console.log('[PROTECTED-ROUTE] Acesso negado: permissão insuficiente', {
//       rotaAdmin: true,
//       cargo: usuario?.cargo
//     });
    return <Navigate to="/dashboard" replace />;
  }
  
  // Usuário autenticado e com permissões corretas
//   console.log(`[PROTECTED-ROUTE] Acesso permitido à rota: ${location.pathname}`, {
//     usuarioId: usuario?.id,
//     cargo: usuario?.cargo
//   });
  return <>{children}</>;
};

export default ProtectedRoute;
